import { getParamFromWindow } from '@office-start/window-utility';
export function applyOfficeContext(requestConfig, correlationId) {
    if (!requestConfig.headers) {
        requestConfig.headers = {};
    }
    requestConfig.headers["X-OfficeHome-CorrelationId" /* CorrelationId */] = correlationId;
    var testTraffic = getParamFromWindow("testtraffic" /* TestTraffic */);
    if (testTraffic) {
        requestConfig.headers["X-OfficeHome-TestTraffic" /* TestTraffic */] = testTraffic;
    }
}
//# sourceMappingURL=applyOfficeContext.js.map